import styled, { css } from "styled-components";
import { Wrapper } from 'AppReact';

const PrimaryBackground50Wrapper = styled.div`
  ${({ theme, displayState }) => css`
    background-color: ${`${theme?.colour?.primary ?? '#1DBD6B'}0D`};
    border-radius: ${displayState?.borderRadius ?? '8px'};
    border: 1px solid ${`${theme?.colour?.primary ?? '#1DBD6B'}0D` ?? '#1DBD6B'};

    &:hover {
      border: 1px solid ${theme?.colour?.primary ?? '#1DBD6B'}
    }
  `}
`;

export default Wrapper(PrimaryBackground50Wrapper)